import { FC } from 'react';

import { Field } from '@savgroup-front-common/core/src/molecules/Field';

import { useGetFileSummaryNewUi } from '../../FileSummaryNewUi.hooks';
import { messages } from '../../messages';

export const FileOwnerField: FC = () => {
  const { data } = useGetFileSummaryNewUi();
  const assignedUserName = data?.context.assignedUserName;

  if (!assignedUserName) {
    return null;
  }

  return (
    <Field label={messages.fileOwner} copy={assignedUserName}>
      {assignedUserName}
    </Field>
  );
};
